import { COMPANY } from "../data/company";
import { LegalLayout } from "../components/LegalLayout";

export default function Confidentialitate() {
  return (
    <LegalLayout
      title="Politica de confidențialitate"
      subtitle="Modul în care colectăm, folosim și protejăm datele tale personale, conform GDPR."
      lastUpdated="Februarie 2026"
    >
      <h2 className="font-heading text-xl font-bold text-slate-900">1. Operatorul de date</h2>
      <p>
        Operatorul datelor cu caracter personal este{" "}
        <strong>{COMPANY.legalName}</strong>, CUI {COMPANY.cui}, Reg. Comerț{" "}
        {COMPANY.regCom}, cu sediul în {COMPANY.address}. Email contact:{" "}
        <a href={`mailto:${COMPANY.email}`} className="text-cyan-600 underline">
          {COMPANY.email}
        </a>
        .
      </p>

      <h2 className="font-heading text-xl font-bold text-slate-900">2. Ce date colectăm</h2>
      <p>Colectăm datele necesare procesării comenzii:</p>
      <ul className="list-disc pl-6 space-y-1">
        <li>Nume și prenume</li>
        <li>Număr de telefon</li>
        <li>Adresa de livrare</li>
        <li>Adresa de email (opțional)</li>
        <li>Mesajele schimbate cu noi pe WhatsApp sau telefon</li>
      </ul>

      <h2 className="font-heading text-xl font-bold text-slate-900">3. Scopul prelucrării</h2>
      <ul className="list-disc pl-6 space-y-1">
        <li>Procesarea și livrarea comenzilor (temei: contract)</li>
        <li>Comunicare cu privire la statusul comenzii (temei: contract)</li>
        <li>Îndeplinirea obligațiilor fiscale și contabile (temei: obligație legală)</li>
        <li>Soluționarea reclamațiilor și retururilor (temei: interes legitim)</li>
      </ul>

      <h2 className="font-heading text-xl font-bold text-slate-900">4. Durata stocării</h2>
      <p>
        Datele sunt păstrate pe durata necesară îndeplinirii scopului colectării
        și conform obligațiilor legale de arhivare (de regulă 10 ani pentru
        documente fiscale).
      </p>

      <h2 className="font-heading text-xl font-bold text-slate-900">5. Cui transmitem datele</h2>
      <p>
        Datele pot fi transmise către: firme de curierat (pentru livrare),
        autoritățile statului (la cerere), contabilul firmei, furnizori IT
        (găzduire site). Nu vindem și nu închiriem datele tale unor terți.
      </p>

      <h2 className="font-heading text-xl font-bold text-slate-900">6. Drepturile tale (GDPR)</h2>
      <p>Conform Regulamentului UE 2016/679, ai următoarele drepturi:</p>
      <ul className="list-disc pl-6 space-y-1">
        <li>Dreptul de acces la date</li>
        <li>Dreptul la rectificare</li>
        <li>Dreptul la ștergere („dreptul de a fi uitat")</li>
        <li>Dreptul la restricționarea prelucrării</li>
        <li>Dreptul la portabilitatea datelor</li>
        <li>Dreptul la opoziție</li>
        <li>
          Dreptul de a depune plângere la <strong>ANSPDCP</strong> (
          <a
            href="https://www.dataprotection.ro"
            target="_blank"
            rel="noopener noreferrer"
            className="text-cyan-600 underline"
          >
            dataprotection.ro
          </a>
          )
        </li>
      </ul>
      <p>
        Pentru exercitarea acestor drepturi, ne poți contacta la{" "}
        <a href={`mailto:${COMPANY.email}`} className="text-cyan-600 underline">
          {COMPANY.email}
        </a>
        .
      </p>

      <h2 className="font-heading text-xl font-bold text-slate-900">7. Securitate</h2>
      <p>
        Aplicăm măsuri tehnice și organizatorice rezonabile pentru a proteja
        datele tale împotriva accesului neautorizat, pierderii sau divulgării.
      </p>

      <h2 className="font-heading text-xl font-bold text-slate-900">8. Cookies</h2>
      <p>
        Detalii despre cookies găsești în{" "}
        <a href="/politica-cookies" className="text-cyan-600 underline">
          Politica de cookies
        </a>
        .
      </p>
    </LegalLayout>
  );
}
